import { EntityQuery, FilterQueryEntity } from '~/types/OpenSearch';

const withQueryFormatItem = (item: EntityQuery): EntityQuery => {
  if (item.type === 'section' && Array.isArray(item.value)) {
    return {
      ...item,
      value: item.value.map(withQueryFormatItem),
    };
  }

  if (item.type !== 'filter') {
    return item;
  }

  const filterItem = item as FilterQueryEntity;
  return { ...filterItem, query_format: 'evisearch' as const };
};

export const withQueryFormat = (query: EntityQuery[]): EntityQuery[] =>
  query.map(withQueryFormatItem);
